import { render, staticRenderFns } from "./ServiceVote.vue?vue&type=template&id=7be13518&scoped=true&"
import script from "./ServiceVote.vue?vue&type=script&lang=js&"
export * from "./ServiceVote.vue?vue&type=script&lang=js&"
import style0 from "./ServiceVote.vue?vue&type=style&index=0&id=7be13518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be13518",
  null
  
)

export default component.exports